import moment from 'moment';
import { PatientDocument } from 'src/models';
import { roundToNext15Minutes } from 'src/modules/ambient_solo/utils/encounterHelper';

type GenerateEncounterDescriptionConfig = {
  prefix?: string;
};

export const generateEncounterDescription = (
  config: GenerateEncounterDescriptionConfig = {}
) => {
  const { prefix } = { prefix: 'Encounter', ...config };
  const currentDate = moment().local();
  const roundedDate = roundToNext15Minutes(currentDate);
  const formattedDate = `${currentDate.month() + 1}/${currentDate.date()}`;
  return `${prefix} - ${formattedDate} ${roundedDate.format('h:mm a')}`;
};

export const mergePatientTextDocuments = (documents: PatientDocument[]) => {
  const notesDocument: { id: string | null; content: string } = {
    id: null,
    content: '',
  };
  const attachments: PatientDocument[] = [];

  (documents || []).forEach((document) => {
    if (document.type === 'text') {
      if (document.content) {
        if (notesDocument.content) {
          notesDocument.content += '\n\n' + document.content;
        } else {
          notesDocument.content = document.content;
        }
      }
      if (!notesDocument.id) {
        notesDocument.id = document.patient_document_id;
      }
    } else {
      attachments.push(document);
    }
  });

  return { notesDocument, attachments };
};
